// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer.svelte-1gl6hd2{border-top:1px solid #e5e5e5}", ""]);
// Exports
module.exports = exports;
